export const navbarSections = [
  'Overview',
  'The Who',
  'The What',
  'The Where',
  'Summary',
] as const;
